import styled from "styled-components";

export const PageHomeContainer = styled.section`
  margin: 10px 10px 0 10px;
  `

export const PageHomeDevices = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  padding-bottom: 15px;

  @media (max-width: 1120px) {
    grid-template-columns: repeat(5, 1fr);
  }
  @media (max-width: 1120px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 760px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 550px) {
    grid-template-columns: repeat(2, 1fr);
  }

`

